import { get } from 'lodash';

const styles = ({ color, margin, padding, typography, fontSize }) => ({
  fieldContainer: {
    padding: `0px ${get(padding, 'p10')}`,
    margin: '0 !important',
  },
  selectField: {
    padding: `${get(padding, 'p2')} ${get(padding, 'p10')} !important`,
  },
  addBtn: {
    float: 'right',
    marginTop: 30,
  },
  listContent: {
    margin: get(margin, 'm0'),
  },
  pageBodyClass: {
    paddingTop: get(padding, 'p0'),
  },
  pageFilterAndSortClass: {
    marginTop: get(margin, 'm24'),
  },
  warningIcon: {
    color: get(color, 'warning'),
    marginLeft: get(margin, 'm10'),
    marginRight: get(margin, 'm4'),
    fontSize: 14,
    marginTop: get(margin, 'm4'),
  },
  tagsContainer: {
    alignSelf: 'flex-end',
    paddingBottom: 10,
    paddingLeft: `${get(padding, 'p10')}`,
    width: 400,
    margin: '0 !important',
  },
  statusIcon: {
    height: 18,
    marginRight: 4,
    verticalAlign: 'middle',
    width: 18,
  },
  dialogContainer: {
    maxWidth: '700px !important',
  },
  headerButtons: {
    marginTop: get(margin, 'm5'),
    marginBottom: get(margin, 'm10'),
  },
  addButton: {
    margin: `0 ${get(margin, 'm2')}`,
  },
  removeButton: {
    backgroundColor: get(color, 'error'),
    borderColor: get(color, 'error'),
    margin: `0 ${get(margin, 'm2')}`,
    '&:hover': {
      backgroundColor: get(color, 'errorHover'),
    },
  },
  panelContent: {
    color: `${get(color, 'bodyText')} !important`,
    fontFamily: `${get(typography, 'bodyText')} !important`,
    fontSize: `${get(fontSize, 'bodyText')} !important`,
    fontWeight: 400,
    lineHeight: 1.5,
    height: 300,
    width: '100%',
    overflowY: 'scroll',
  },
  apiGroupPanel: {
    color: get(color, 'pageTitle'),
  },
  paperClass: {
    width: '65%',
    height: 610,
    maxWidth: 'none',
    '& button:focus': {
      outlineWidth: '1px !important',
      outlineOffset: '1px !important',
      outlineStyle: 'solid !important',
      outlineColor: get(color, 'primaryButtonBackground'),
    },
  },
  accordionTitleBold: {
    fontWeight: 700,
    fontSize: `${get(fontSize, 'bodyText')} !important`,
  },
  accordionTitle: {
    fontSize: `${get(fontSize, 'bodyText')} !important`,
  },
  tableContainer: {
    '& tr th:first-child, tr td:first-child': {
      paddingLeft: `${get(padding, 'p0')} !important`,
    },
  },
});

export default styles;
